import { IOperationListPayload, OPERATION_TYPE } from '../models/operations.models';

/**
 * Convierte filtros UI del listado mensajería al contrato `POST /operations` con TFA.
 * Elimina `messaging_channel` y `operation_types_uuid` del body API.
 */
export function buildMessagingApiPayload(filters: IOperationListPayload | undefined): IOperationListPayload {
	const source = { ...(filters ?? {}) };
	const messagingChannel = source.messaging_channel;
	delete source.messaging_channel;
	delete source.operation_types_uuid;

	const payload: IOperationListPayload = {
		...source,
		has_2fa: true,
	};

	if (messagingChannel === OPERATION_TYPE.SMS) {
		payload.channel = 'sms';
	} else if (messagingChannel === OPERATION_TYPE.WHATSAPP) {
		payload.channel = 'whatsapp';
	}

	return payload;
}
